import CaladreTheme from "theme/Theme";

const classes = {
  msgZone: {
    width: "100%",
    my: 2,
    "& .MuiInputBase-root": {
      width: "100%",
      padding: CaladreTheme.spacing(1, 1),
      backgroundColor: "#E8E7E7",
      borderRadius: "12px",
      "& .MuiInputBase-input": {
        fontSize: "12px",
        padding: `${CaladreTheme.spacing(1, 1)} !important`,
      },
    },
  },
};
export default classes;
